module.exports = __webpack_public_path__ + "static/LogoClickup-d04c45d2b2202c7a08a1c85e12692270.png";